import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

// Acesso ao CRM restrito a um conjunto explícito de usuários.
// Centralizado aqui pra um único ponto de verdade — backend espelha em requireCrmUser.
const CRM_ALLOWED_USER_IDS = [12];

export const isCrmUser = (user) => !!user && CRM_ALLOWED_USER_IDS.includes(user.id);

const CrmRoute = ({ children }) => {
    const { user, isAuthenticated, loading } = useAuth();

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Carregando...</span>
                </div>
            </div>
        );
    }

    if (!isAuthenticated()) return <Navigate to="/login" replace />;
    if (!isCrmUser(user))  return <Navigate to="/home"  replace />;

    return children;
};

export default CrmRoute;
